module.exports = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}



// WEBPACK FOOTER //
// ../node_modules/berries/lib/capitalize.js